import { size, get, isArray, reduce, map, forEach, isUndefined } from 'lodash';
import Dinero from './dinero';

export const getDefaultPartyGroupAllocations = (parties = [], total = 100, precision = 100) => {
  if (!isArray(parties) || size(parties) === 0) {
    return {};
  }
  const paxPerParty = reduce(
    parties,
    (acc, party) => {
      acc.push(size(party.travelers));
      return acc;
    },
    [],
  );
  // no parties have travelers
  if (paxPerParty.every(count => count === 0)) {
    return {};
  }

  // @todo: do we need to support > 100 for the party group thingy?
  const amount = total * precision;
  // let Dinero do the allocation so it's consistent
  const allocations = Dinero({ amount, currency: 'USD' }).allocate(paxPerParty);

  // these are index based so just mash them back together
  return allocations.reduce((acc, allocation, index) => {
    acc[parties[index].id] = allocation.toUnit();
    return acc;
  }, {});
};

export const getPartyAllocations = (instance = {}, parties = []) => {
  const segments = get(instance, 'itinerary.segments', []);
  //   console.log('getPartyAllocations', segments);
  if (size(segments) > 0 && size(parties) > 0) {
    const currency = get(instance, 'finance.currency', 'USD');
    const defaultPartyGroupAllocations = getDefaultPartyGroupAllocations(parties);
    // should probably use an actual Map
    const partyGroupTotalsMap = reduce(
      parties,
      (acc, party) => {
        acc[party.id] = {
          // @todo: deprecate `amount`
          amount: 0,
          sell: 0,
          deposit: 0,
          deposit_fee_credit: 0,
          deposit_fee_ach: 0,
          currency,
        };
        return acc;
      },
      {},
    );

    // allocate parties total sell based on percentages, with default fallbacks
    segments.forEach(segment => {
      const segmentPartyAllocations = map(parties, party => {
        const allocation = get(party, `allocations.${segment.id}.allocation`);
        if (isUndefined(allocation)) {
          return defaultPartyGroupAllocations[party.id];
        }
        return allocation;
      });
      const amount = Dinero({ amount: segment.sellAmount || 0, currency });
      const segmentAllocation = amount.allocate(segmentPartyAllocations);
      forEach(parties, (party, index) => {
        // add the sell allocation to the total sell for the party.
        // @todo: need to remove `amount` in lieu of `sell`, make sure things dont break
        partyGroupTotalsMap[party.id].amount += segmentAllocation[index].getAmount();
        partyGroupTotalsMap[party.id].sell += segmentAllocation[index].getAmount();
      });
    });

    // allocate deposits, deposit fees and sell fees based on the percentage of total sell the party has via Dinero.allocate
    const amounts = map(parties, party => partyGroupTotalsMap[party.id].amount);
    // if all amounts are 0 we cannot .allocate
    if (amounts.every(amount => amount === 0)) return partyGroupTotalsMap;
    const depositAllocation = Dinero({ amount: instance.finance.deposit, currency }).allocate(amounts);
    const depositFeeCreditAllocation = Dinero({ amount: instance.finance.deposit_fee_credit, currency }).allocate(amounts);
    const depositFeeAchAllocation = Dinero({ amount: instance.finance.deposit_fee_ach, currency }).allocate(amounts);

    const sellFeeCreditAllocation = Dinero({ amount: instance.finance.sell_fee_credit, currency }).allocate(amounts);
    const sellFeeAchAllocation = Dinero({ amount: instance.finance.sell_fee_ach, currency }).allocate(amounts);

    parties.forEach((party, index) => {
      partyGroupTotalsMap[party.id].deposit = depositAllocation[index].getAmount();
      partyGroupTotalsMap[party.id].deposit_fee_credit = depositFeeCreditAllocation[index].getAmount();
      partyGroupTotalsMap[party.id].deposit_fee_ach = depositFeeAchAllocation[index].getAmount();
      partyGroupTotalsMap[party.id].sell_fee_credit = sellFeeCreditAllocation[index].getAmount();
      partyGroupTotalsMap[party.id].sell_fee_ach = sellFeeAchAllocation[index].getAmount();
    });

    return partyGroupTotalsMap;
  }
  return {};
};
